import { authedEndpoint } from "~/lib/api/builder";
import { Locales } from "~/lib/api/schemas/basic-settings";

export const list = authedEndpoint.query(
    () => ({
        url: "settings/system-locales",
    }),
    {
        output: Locales,
    },
);
